module.exports = require("@pb/kit-component-scrollable-area");